enum CustomErrorsID {
	Unknow_Error = 'unknow_error',
	//
	Firebase_error = 'firebase_error',
	//
	Account_not_visible = 'account_not_visible',
	Request_params_wrong = 'request_params_wrong',
	Invalid_email_address = 'invalid_email_address',
	Violates_unique_constraint = 'violates_unique_constraint',
	Violates_foreign_key = 'violates_foreign_key',
	Send_limit_reached = 'send_limit_reached',
	Number_not_blank = 'number_not_blank',
	Invoices_account_id_number_key = 'invoices_account_id_number_key',
	Estimates_account_id_number_key = 'estimates_account_id_number_key',

	Gin_anonymous_required		= 'gin_anonymous_required',
	Gin_auth_required			= 'gin_auth_required',
	Gin_registered_required		= 'gin_registered_required',
	Gin_administrator_required	= 'gin_administrator_required',

	User_email_already_associated = 'user_email_already_associated',
	User_invitation_code_invalid  = 'user_invitation_code_invalid',
	User_account_disabled		  = 'user_account_disabled'
}

enum CustomErrorType {
	None = '',
	Error = 'error',
	Warning = 'warning'
}

export type CustomError = {
	type: CustomErrorType
	id: string
	message: string
}

export const CustomErrorMgr = {
	// Access to enum Errors ID
	ErrorsID: CustomErrorsID,

	// Manage error Types
	HasErrorInfo: function (jsonError: CustomError) {
		return jsonError && jsonError.type != CustomErrorType.None
	},
	IsUnknowError: function (jsonError: CustomError) {
		if (CustomErrorMgr.IsError(jsonError) && jsonError.id == CustomErrorsID.Unknow_Error) {
			return true
		}
		return false
	},
	IsError: function (jsonError: CustomError) {
		return jsonError.type == CustomErrorType.Error
	},
	IsWarning: function (jsonError: CustomError) {
		return jsonError.type == CustomErrorType.Warning
	},

	// Determine if the a specific error
	IsWithID: function (jsonError: CustomError, id: string) {
		return jsonError.id == id
	}
}
